// Color Palette (single source of truth)
export const colors = {
  primary: "#e67e22",
  secondary: "#4f6b35",
  accent: "#d6b36a",
  light: "#ebd5ab",
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    400: "#9ca3af",
    600: "#4b5563",
    700: "#374151",
    950: "#030712",
  },
  white: "#ffffff",
  black: "#000000",
};

// Typography
export const typography = {
  heading: {
    h1: "text-5xl md:text-6xl font-light leading-tight",
    h2: "text-4xl md:text-5xl font-light leading-tight",
    h3: "text-2xl font-semibold",
    h4: "text-xl font-semibold",
  },

  card: {
    large: "text-2xl font-semibold leading-snug transition-colors duration-300",
    base: "text-base font-semibold leading-snug transition-colors duration-300",
  },

  body: {
    large: "text-lg text-gray-700 leading-relaxed font-light",
    base: "text-base text-gray-700 leading-relaxed font-light",
    small: "text-sm text-gray-600 leading-relaxed",
    xs: "text-xs text-gray-500",
  },

  label: "text-xs font-semibold tracking-widest uppercase",
};

// Spacing
export const spacing = {
  section: "py-24 md:py-32",
  sectionGap: "space-y-32 md:space-y-48",
  container: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
  cardGap: "gap-16",
  smallGap: "gap-4",
};

// Shadow & Border
export const effects = {
  shadow: {
    sm: "shadow-sm",
    md: "shadow-md",
    lg: "shadow-lg",
    xl: "shadow-xl",
    "2xl": "shadow-2xl",
  },
  border: {
    light: "border border-gray-200/60",
    lightHeavy: "border border-gray-200/80",
  },
  radius: {
    sm: "rounded-2xl",
    md: "rounded-3xl",
    lg: "rounded-full",
  },
};

// Reusable Component Classes
export const components = {
  button: {
    primary:
      "inline-flex items-center gap-3 bg-primary text-white px-8 py-4 rounded-full font-semibold shadow-lg hover:shadow-xl hover:scale-105 hover:-translate-y-0.5 transition-all duration-300",
    secondary:
      "inline-flex items-center gap-2 rounded-full border border-gray-200 text-gray-600 hover:border-gray-400 hover:scale-105 transition-all duration-300",
    small:
      "inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2.5 text-sm font-medium text-white hover:bg-secondary hover:shadow-xl hover:scale-105 hover:-translate-y-0.5 transition-all duration-300",
  },
  card: {
    base: "relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 group",
    light:
      "relative bg-white/80 backdrop-blur-sm rounded-2xl border border-gray-200/60 hover:border-primary/40 hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group",
    dark: "relative bg-gradient-to-br from-gray-900 to-gray-950 rounded-3xl border border-gray-200/60 overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-300",
  },
  badge: "text-xs font-semibold tracking-widest uppercase text-gray-400",
  input:
    "w-full px-4 py-3 rounded-xl border border-gray-200/60 bg-white/80 focus:outline-none focus:border-primary/40 focus:bg-white transition-all duration-300",
};

// Gradients
export const gradients = {
  accent: "bg-gradient-to-r from-primary to-accent",
  subtle: "bg-gradient-to-br from-white to-light/20",
  dark: "bg-gradient-to-br from-gray-900 to-gray-950",
};
